module.exports = __webpack_public_path__ + "static/media/building-solid.61c73aa5.svg";